import { useState } from "react";
import { Jurados, initialValuesinfoJurados } from "../models/JuradosModel/jurados.model";

export const useInfoJurados = () => {
  const [principalState, setPrincipalState] = useState<Jurados>(initialValuesinfoJurados);
  const onChange = (e: any) => {
    console.log(e);
    setPrincipalState({ ...principalState, activeTab: e });
  };
  const onFinish = () => {
    //console.log("aca");
  };
  return { principalState, setPrincipalState, onFinish, onChange };
};
